<template>
  <b-container v-if="createAny('users')" fluid>

    <!-- Title bar -->
    <div class="title-bar">
      <h1>{{ $t("titles.hourcategories") }}</h1>
      <div @click="edit_hourcategory({ id: 0})" class="btn btn-primary">
        <font-awesome-icon icon="plus" /> {{ $t("buttons.addhourcategory") }}
      </div>
    </div>
    <input v-model="refresh" type="hidden">

    <!-- Filter bar -->
    <b-row class="filter-bar">
      <b-col>
        <b-form-group :label="$t('labels.filter')">
          <b-form-input id="filter-input" v-model="filter" type="search" :placeholder="$t('strings.typetosearch')">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Table -->
    <b-table sort-icon-left :items="hourcategories" :fields="fields" :current-page="currentPage" :per-page="perPage"
      :filter="filter" :filter-included-fields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection" @filtered="onFiltered" @row-clicked="edit_hourcodes">
      <template #cell(active)="row">
        <font-awesome-icon v-if="row.item.active" icon="check" style="color: green;"
          :title="$t('labels.editcategorieoff')" />
        <font-awesome-icon v-else icon="times" style="color: red;" :title="$t('labels.editcategorieon')" />
      </template>
      <template #cell(pulldown)="row">
        <b-dropdown id="dropdown-dropup" dropup :text="$t('buttons.doaction')" variant="primary">
          <b-dropdown-item @click="confirm_delete_hourcategory(row.item.id)">
            <font-awesome-icon icon="trash" /> {{$t('labels.deletecategorie')}}
          </b-dropdown-item>
          <b-dropdown-item @click="edit_hourcategory(row.item)">
            <font-awesome-icon icon="cog" /> {{$t('labels.editcategorie')}}
          </b-dropdown-item>
          <b-dropdown-item @click="edit_hourcodes(row.item)">
            <font-awesome-icon icon="tools" /> {{$t('labels.editcategorieuurcode')}}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>

    <b-pagination v-if="totalRows > perPage" v-model="currentPage" :total-rows="totalRows" :per-page="perPage">
    </b-pagination>
  </b-container>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import hourcategory_details_modal from './modals/HourCategoryModal'
import popup_modal from './modals/PopupModal.vue'

export default {
  name: 'hourcategoriesscreen',
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      selectedID: null,
      refresh:0



    }
  },
  computed: {
    totalRows() {
      return this.hourcategories.length
    },
    fields() {
      return [
        { key: 'id', label: this.$i18n.t('labels.hourcategoryname'), formatter: "categorynames", sortable: true, sortDirection: 'desc' },
        { key: 'active', label: this.$i18n.t('labels.active') },
        { key: 'pulldown', label: this.$i18n.t('labels.actions') },
      ]
    },
    ...mapState([
      'hourcodes',
      'hourcategories'
    ]),
    ...mapGetters([
      'hourcategory_by_id',
      'confirm_modal',
      'createAny'

    ])

  },
  methods: {

    confirm_delete_hourcategory(id) {
      this.selectedID = id
      let message = this.$i18n.t('labels.confirmdeletehead') + this.hourcategory_by_id(id).name + this.$i18n.t('labels.confirmdeletetail')
      this.$modal.hide('popup_modal')
      this.$modal.show(popup_modal, {
        message: message,
      }, {
        name: 'popup_modal',
        draggable: false,
        height: 'auto',
        width: '500px'
      }, {
        'before-close': this.modalClose
      })

      this.$emit('close')

    },
    modalClose() {
      if (this.confirm_modal.id == 1) {
        this.delete_hourcategory(this.selectedID);
        for (let i = 0; i < this.hourcategories.length; i++) {
          if (this.hourcategories[i].id == this.selectedID) {
            this.hourcategories.splice(i, 1);
          }
        }
      }
    },
    updateview(){
      this.$store.dispatch('get_hourcategories')

      this.refresh++
    },    
    ...mapActions([
      'delete_hourcategory',
      'save_hourcategory'
    ]),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    edit_hourcodes(row) {
      this.$router.push({ path: '/hours/' + row.id });
    },
    edit_hourcategory(hourcategory) {
      this.$modal.hide('hourcategory_details_modal')
      this.$modal.show(hourcategory_details_modal, {
        hourcategory_id: hourcategory.id,
      }, {
        name: 'hourcategory_details_modal',
        draggable: '.popup-header',
        height: 'auto',
        width: '800px'
      }, {
        'before-close': this.updateview
      })

      this.$emit('close')
    },
    categorynames(id) {
      let hourcodesinbranche = this.hourcodes.filter(code => code.hour_category_id == id)
      return this.hourcategory_by_id(id).name + " (" + hourcodesinbranche.length + ")"
    }
  },
  watch:{
    hourcategories: function () {
      this.refresh++
    }
  }
}
</script>
